const TOKEN_KEY = "fbs_admin_token";

export const getApiBase = () =>
  (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/$/, "");

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);

export const setAdminToken = (token) => {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
};

async function request(path, { method = "GET", body, auth = false } = {}) {
  const headers = { Accept: "application/json" };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (auth) {
    const token = getAdminToken();
    if (!token) {
      const err = new Error("Not authenticated");
      err.status = 401;
      throw err;
    }
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${getApiBase()}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { detail: text };
    }
  }

  if (!res.ok) {
    const detail = data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d) => d.msg || JSON.stringify(d)).join("; ")
      : detail || res.statusText || "Request failed";
    const err = new Error(typeof message === "string" ? message : "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export const adminLogin = (username, password) =>
  request("/api/admin/login", { method: "POST", body: { username, password } });

export const adminMe = () => request("/api/admin/me", { auth: true });

export const fetchCustomBrokers = () => request("/api/brokers/custom");

export const adminListBrokers = () => request("/api/admin/brokers", { auth: true });

export const adminCreateBroker = (broker) =>
  request("/api/admin/brokers", { method: "POST", body: broker, auth: true });

export const adminDeleteBroker = (slug) =>
  request(`/api/admin/brokers/${encodeURIComponent(slug)}`, { method: "DELETE", auth: true });

export const adminBulkUpsertBrokers = (brokers) =>
  request("/api/admin/brokers/bulk", { method: "POST", body: brokers, auth: true });
